export enum ArrowKind {
    TwoWay,
    FourWay,
    EightWay,
}

